import axiosInstance from '@/api/axiosInstance';
import { ListPathsParams, ListPathsResponse } from '@/modules/learningCenter/features/LearningPaths/apiTypes';

/**
 * Fetch learning paths with filtering
 * GET /api/learning-paths
 *
 * @param params - Query parameters for filtering learning paths
 * @param params.companyId - Filter by company ID
 * @param params.createdBy - Filter by creator user ID
 * @param params.isArchived - Filter by archive status
 * @param params.search - Search by path name or description
 * @returns Promise resolving to list of learning paths with total count
 */
export const fetchLearningPaths = async (
  params?: ListPathsParams
): Promise<ListPathsResponse> => {
  try {
    const response = await axiosInstance.get<{data: any[], meta?: {totalCount?: number}}>(
      '/api/learning-paths',
      { params }
    );

    // Backend returns {data: [...], meta: {totalCount: N}}
    // Frontend expects {paths: [...], total: N}
    return {
      paths: response.data.data || [],
      total: response.data.meta?.totalCount || 0,
    };
  } catch (error) {
    console.error('Error fetching learning paths:', error);
    // Return empty result instead of throwing to prevent UI crashes
    // This allows the UI to render gracefully when the backend endpoint doesn't exist yet
    return { paths: [], total: 0 };
  }
};
